var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D8D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9971 20H19.9971C17.2396 20 14.9971 22.2425 14.9971 25V55C14.9971 57.7575 17.2396 60 19.9971 60H59.9971C62.7546 60 64.9971 57.7575 64.9971 55V25C64.9971 22.2425 62.7546 20 59.9971 20ZM26.2471 27.5C27.2416 27.5 28.1955 27.8951 28.8987 28.5983C29.602 29.3016 29.9971 30.2554 29.9971 31.25C29.9971 32.2446 29.602 33.1984 28.8987 33.9017C28.1955 34.6049 27.2416 35 26.2471 35C25.2525 35 24.2987 34.6049 23.5954 33.9017C22.8922 33.1984 22.4971 32.2446 22.4971 31.25C22.4971 30.2554 22.8922 29.3016 23.5954 28.5983C24.2987 27.8951 25.2525 27.5 26.2471 27.5ZM39.9971 52.5H22.4971L32.4971 40L36.2471 45L43.7471 35L57.4971 52.5H39.9971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.ce48b1e6f062a5d4e7ba358c0ae77932.svg";
export { ForwardRef as ReactComponent };